/**
 * region for libraries*/
import React, { Component } from 'react';
import { Route } from 'react-router';

/**
 * region for component*/
import { NavigationMenu } from './NavigationMenu';
import { Dashboard } from './dashboard/DashboardChart';
import { Activity } from './activity/Activity';

export class IndexActivityLog extends Component {
    static displayName = IndexActivityLog.name;

    constructor(props) {
        super(props);
        this.state = {
            modeExpanded: true
        };

    }

    handleCollapsedSidebar() {
        const self = this;
        self.setState({
            modeExpanded: !self.state.modeExpanded
        });
    }

    render() {

        let classContainer;
        if (!this.state.modeExpanded) {
            classContainer = "container-expanded"
        } else {
            classContainer = " "
        }

        return (
            <div className={classContainer}>
                <NavigationMenu modeExpanded={this.state.modeExpanded} onCollapsedSidebar={this.handleCollapsedSidebar.bind(this)} />
                <Route exact path='/indexActivityLog/activity' component={Activity} />
                <Route exact path='/indexActivityLog/dashboard' component={Dashboard} />
            </div>
        );
    }

}
export default IndexActivityLog;
